/* Store initialization */
export const UPDATE_PAGINATION = 'UPDATE_PAGINATION'
export const ADD_PAGE = 'ADD_PAGE'
